<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container">
      <div class="dashboardAdmin-header d-flex align-items-center">
        <img
          v-if="vendorData && Object.keys(vendorData).length == 0"
          @click="gotoClient()"
          src="../../assets/img/feedbackform/backarrow.svg"
          class="pointer"
          alt=""
        />
        <div class="dashboardAdmin-header-main-head ml-2 position-relative">
          <span>{{ $route.params.client }}</span>
        </div>
      </div>
      <div class="d-flex align-items-center mt-2 w-100">
        <div class="w-70 vf-main-containers">
          <div class="m-3 d-flex align-items-center justify-content-between">
            <div class="wb-subheading">List of Jobs</div>
            <div class="position-relative">
              <b-button
                class="acs-addBtn"
                ref="filter-btn"
                @click="showFilterCard = !showFilterCard"
                ><img
                  class="mr-2"
                  src="../../assets/img/accessconnew/whiteFilter.svg"
                  alt=""
                />
                <div
                  class="mb-3"
                  style="position: absolute; top: 1px; left: 38px"
                  v-if="selectedSort"
                >
                  <img src="../../assets/panelist/fil_selected.svg" alt="" />
                </div>
                Filter</b-button
              >
              <div
                style="top: 35px; right: 0px"
                v-if="showFilterCard"
                class="acs-filter p-3"
                ref="filter-box"
                v-closable="{
                  exclude: ['filter-btn', 'filter-box'],
                  handler: 'hideFilterBox',
                }"
              >
                <div>
                  <div>
                    <div class="acs-black-txt">Sort By :</div>
                    <div
                      ref="rec"
                      @click="(sortCard = !sortCard), (typeCard = false)"
                      class="acs-filter-dropdown mt-2 position-relative pointer"
                    >
                      <span
                        v-if="!customerSort"
                        class="acs-filter-dropdown-place"
                      >
                        Select
                      </span>
                      <span v-else>
                        {{ sortName }}
                      </span>

                      <img
                        class="mr-2"
                        src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
                        alt=""
                      />
                    </div>
                    <div
                      ref="recdropdown"
                      v-closable="{
                        exclude: ['rec', 'recdropdown'],
                        handler: 'hideSortDropdown',
                      }"
                      v-if="sortCard"
                      class="relativeclass"
                    >
                      <div class="newInt-radio-dropdown p-0">
                        <b-form-group class="sec-mcq-datacard">
                          <b-form-radio-group
                            class="newInt-radio-dropdown-inner-content w-100"
                            size="sm"
                            v-model="customerSort"
                            :options="sort_options"
                            @change="sortCard = false"
                            buttons
                            stacked
                          >
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="mt-3">
                    <div class="acs-black-txt">Customer Status :</div>
                    <div
                      @click="(typeCard = !typeCard), (sortCard = false)"
                      class="acs-filter-dropdown mt-2 position-relative pointer"
                    >
                      <span class="acs-filter-dropdown-place">
                        {{
                          customerType === "0"
                            ? "Inactive"
                            : customerType === "1"
                            ? "Active"
                            : "All"
                        }}</span
                      >
                      <img
                        class="mr-2"
                        src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
                        alt=""
                      />
                    </div>
                    <div v-if="typeCard" class="relativeclass">
                      <div class="newInt-radio-dropdown p-0">
                        <b-form-group class="sec-mcq-datacard">
                          <b-form-radio-group
                            class="newInt-radio-dropdown-inner-content w-100"
                            size="sm"
                            v-model="customerType"
                            :options="jdtypeoptions"
                            @change="typeCard = false"
                            buttons
                            stacked
                          >
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                    </div>
                  </div> -->
                  <div class="d-flex justify-content-between mt-4">
                    <b-button
                      class="acs-cancelBtn-filter"
                      @click="cancelFilter()"
                      >Cancel</b-button
                    >
                    <div class="d-flex">
                      <b-button
                        :disabled="!selectedSort"
                        class="acs-cancelBtn-filter mr-3"
                        @click="resetSort()"
                        >Reset</b-button
                      >
                      <b-button
                        :disabled="!customerSort"
                        @click="applyFilter()"
                        class="acs-cancelBtn-filter"
                        >Apply</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="m-0" />
          <div
            v-if="vendorDetails.length != 0"
            @scroll="onScroll"
            style="height: calc(100vh - 230px)"
            class="overflow-auto pl-2 mr-1"
          >
            <div class="d-flex flex-wrap pb-2">
              <div
                :class="selectedJD.jobID == job.jobID && 'selected-job-card'"
                v-for="job in vendorDetails"
                :key="job.jobID"
                @click="goToKanban(job)"
                class="position-relative new-cardv-main pointer"
              >
                <div class="d-flex">
                  <div style="width: 10%">
                    <img
                      src="../../assets/img/newvendorflow/vendorcard.svg"
                      alt=""
                    />
                  </div>
                  <div
                    class="ml-2 newInt-card-heading mt-1 text-truncate"
                    style="width: 80%"
                  >
                    <span
                      class="d-inline-block text-truncate"
                      style="max-width: 95%"
                      v-b-tooltip.hover="job.title"
                      >{{ job.title }}
                    </span>
                  </div>
                  <div style="width: 10%">
                    <img
                      v-if="selectedJD.jobID == job.jobID"
                      class="pointer"
                      @click.stop="showPreview(job)"
                      src="../../assets/img/newcreatejob/hideicon.svg"
                      alt=""
                    />
                    <img
                      v-else
                      class="pointer"
                      @click.stop="showPreview(job)"
                      src="../../assets/img/newvendorflow/view.svg"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  class="
                    mt-2
                    d-flex
                    justify-content-around
                    d-flex
                    align-items-center
                    new-wb-subcards
                  "
                >
                  <div class="d-flex align-items-center flex-column">
                    <div class="wb-new-greenfont">
                      {{ job.positions }}
                    </div>
                    <div class="wb-new-greyfont">Positions</div>
                  </div>

                  <div class="d-flex align-items-center flex-column">
                    <div class="wb-new-bluefont">
                      {{ job.details.candidates }}
                    </div>
                    <div class="wb-new-greyfont">Candidates</div>
                  </div>
                  <div class="d-flex align-items-center flex-column">
                    <div class="wb-new-yellowfont">
                      {{ job.details.pushed }}
                    </div>
                    <div class="wb-new-greyfont">Pushed</div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style="margin: auto"
              v-if="showLoader"
              class="d-flex justify-content-center"
            >
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
          <div
            v-else
            style="height: calc(100vh - 230px)"
            class="overflow-auto m-3 pl-2"
          >
            <div
              v-if="
                !LoaderStatus &&
                vendorDetails.length === 0 &&
                searchQuery !== ''
              "
              class="
                d-flex
                justify-content-center
                align-items-center
                h-100
                flex-column
              "
            >
              <div>
                <img
                  src="../../assets/img/accessconnew/emptyprivilageBig.svg"
                  alt
                />
              </div>
              No matching results for&nbsp;
              <strong> "{{ searchQuery }}" </strong>
            </div>

            <div
              v-else-if="
                !LoaderStatus &&
                vendorDetails.length === 0 &&
                searchQuery === ''
              "
              class="
                d-flex
                justify-content-center
                align-items-center
                h-100
                flex-column
              "
            >
              <div>
                <img
                  src="../../assets/img/accessconnew/emptyprivilageBig.svg"
                  alt
                />
              </div>
              <div class="search-result-empty-text mt-4">
                No Jobs allocated.
              </div>
            </div>
          </div>
        </div>
        <div class="w-30 vf-main-containers ml-2">
          <template v-if="jobpreview">
            <div class="d-flex align-items-center p-3">
              <div class="newInt-rs-mainhead ml-2">Job Details</div>
            </div>
            <hr class="m-0" />
            <div class="ihd-jobdeatils h-90 overflow-auto p-3">
              <div
                class="mt-3"
                v-for="(field, index) in filteredFields()[0]"
                :key="index"
              >
                <div class="newInt-rs-head">{{ field.label }}</div>

                <div v-if="checkFieldKeys(field)">-</div>
                <div
                  class="newInt-rs-subhead mt-1"
                  style="word-break: keep-all"
                  v-else-if="Object.keys(selectedJD).length > 0"
                >
                  <template v-if="isHtmlContent(field)">
                    <div v-html="checkValuesOfKey(field)"></div>
                  </template>
                  <template v-else>
                    {{ checkValuesOfKey(field) }}
                  </template>
                </div>
              </div>
              <div v-if="filteredFields()[1].length != 0" class="mt-3">
                <div
                  class="d-flex align-items-center pointer"
                  @click="showAdvanced = !showAdvanced"
                >
                  <img
                    v-if="!showAdvanced"
                    src="../../assets/img/newworkbench/internalhiring/advance.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/newworkbench/internalhiring/advanceUp.svg"
                    alt=""
                  />
                  <span class="ihd-advance-text ml-2 mr-2">Advanced</span>
                  <hr />
                </div>
              </div>
              <template v-if="filteredFields()[1].length != 0 && showAdvanced">
                <div
                  class="mt-3"
                  v-for="(field, index) in filteredFields()[1]"
                  :key="index + 'adv'"
                >
                  <div class="newInt-rs-head">{{ field.label }}</div>

                  <div v-if="checkFieldKeys(field)">-</div>
                  <div
                    class="newInt-rs-subhead mt-1"
                    style="word-break: keep-all"
                    v-else-if="Object.keys(selectedJD).length > 0"
                  >
                    <template v-if="isHtmlContent(field)">
                      <div v-html="checkValuesOfKey(field)"></div>
                    </template>
                    <template v-else>
                      {{
                        field.key === "openingsCount"
                          ? selectedJD.positions
                          : checkValuesOfKey(field)
                      }}
                    </template>
                  </div>
                </div>
                <hr v-if="vendorRounds > 0" />
              </template>
              <div v-if="vendorRounds > 0" class="ihd-ip-container mt-3">
                <div class="ihd-ip-mainhead">Interview Process</div>
                <div
                  class="mt-3 d-flex w-100"
                  v-for="(interview, index) in selectedJDProcess"
                  :key="index + 'interview'"
                >
                  <div class="position-relative">
                    <div class="ihd-ip-side-circle"></div>
                    <div
                      v-if="index < selectedJDProcess.length - 1"
                      class="ihd-ip-side-line"
                    ></div>
                  </div>
                  <div class="d-flex justify-content-between ml-3 w-90">
                    <div>
                      <div class="ihd-ip-main-head">
                        {{
                          interview.type === "f2f"
                            ? "Face to face"
                            : "Assessment"
                        }}
                      </div>
                      <div class="ihd-ip-sub-head">{{ interview.name }}</div>
                    </div>
                    <div>
                      <img
                        v-if="interview.type === 'f2f'"
                        src="../../assets/img/newworkbench/internalhiring/ipf2fround.svg"
                        alt=""
                      />
                      <img
                        v-else
                        src="../../assets/img/newworkbench/internalhiring/ipasmntround.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <!-- <div class="mt-3 d-flex w-100">
                  <div class="position-relative">
                    <div class="ihd-ip-side-circle"></div>
                  </div>
                  <div class="d-flex justify-content-between ml-3 w-90">
                    <div>
                      <div class="ihd-ip-main-head">Face to face</div>
                      <div class="ihd-ip-sub-head">Python programming</div>
                    </div>
                    <div>
                      <img
                        src="../../assets/img/newworkbench/internalhiring/ipf2fround.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div> -->
              </div>
              <!-- <hr />
              <div class="mt-3 ihd-allocate-container">
                <div class="ihd-allocate-maintxt">Job status</div>
                <div
                  v-for="(activity, index) in selectedJD.activity"
                  :key="index + 'activitiy'"
                >
                  <div
                    class="
                      mt-2
                      ihd-right-deatils-heading
                      d-flex
                      justify-content-between
                      align-items-center
                    "
                  >
                    <div v-if="activity.movedTo === '2'">Job Created By:</div>
                    <div v-else>Approver:</div>
                    <div>{{ formattedDate(activity.time, "dd-MM-yyyy") }}</div>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div class="ihd-ip-sub-head">{{ activity.name }}</div>
                    <div class="ihd-jobstatus-approvals-container">
                      <img
                        v-if="activity.movedTo === '2'"
                        src="../../assets/img/newworkbench/internalhiring/noti-sentfrapproval.svg"
                        alt=""
                      />
                      <img
                        v-else-if="activity.movedTo === '3'"
                        src="../../assets/img/newworkbench/internalhiring/accepted-tick.svg"
                        alt=""
                      />
                      <img
                        v-else-if="activity.movedTo === '4'"
                        src="../../assets/img/newworkbench/internalhiring/rejected-small.svg"
                        alt=""
                      />
                      <span class="ihd-jobstatus-noti-txt ml-2">{{
                        activity.status
                      }}</span>
                    </div>
                  </div>
                </div>
              </div> -->
              <!-- <div class="ihd-jobdeatils h-90 overflow-auto">
            <div>
              <div class="ihd-right-deatils-heading">Job Name</div>
              <div class="ihd-right-detail-subheads mt-7px">Designing</div>
            </div>
            <div class="mt-3">
              <div class="ihd-right-deatils-heading">Job Type</div>
              <div class="ihd-right-detail-subheads mt-7px">Design</div>
            </div>
            <div class="mt-3">
              <div class="ihd-right-deatils-heading">Job Role</div>
              <div class="ihd-right-detail-subheads mt-7px">UI/UX Designer</div>
            </div>
            <div class="mt-3">
              <div class="ihd-right-deatils-heading">Job Description</div>
              <div class="ihd-right-detail-subheads mt-7px">
                Developing intuitive and engaging user interfaces for digital
                products. Their responsibilities include understanding user
                behaviors, creating wireframes and prototypes, and implementing
                visually appealing design elements.
              </div>
            </div>
            <div class="mt-3">
              <div class="ihd-right-deatils-heading">Job Description</div>
              <div class="ihd-right-detail-subheads mt-7px">
                Developing intuitive and engaging user interfaces for digital
                products. Their responsibilities include understanding user
                behaviors, creating wireframes and prototypes, and implementing
                visually appealing design elements.
              </div>
            </div>
            <div class="mt-3">
              <div class="ihd-right-deatils-heading">
                Education Qualification
              </div>
              <div class="ihd-right-detail-subheads mt-7px">
                Graduation/Diploma
              </div>
            </div>
            <div class="mt-3">
              <div class="ihd-right-deatils-heading">No. of Openings</div>
              <div class="ihd-right-detail-subheads mt-7px">5</div>
            </div>
            <div class="mt-3">
              <div class="ihd-right-deatils-heading">No. of Openings</div>
              <div class="ihd-right-detail-subheads mt-7px">50</div>
            </div>
            <div class="mt-3">
              <div class="ihd-right-deatils-heading">Gender</div>
              <div class="ihd-right-detail-subheads mt-7px">Female</div>
            </div>
          </div> -->
            </div>
          </template>

          <div
            v-else
            class="
              d-flex
              flex-column
              align-items-center
              justify-content-center
              h-100
              w-100
            "
          >
            <img src="../../assets/img/newvendorflow/emptyjob.svg" alt="" />
            <div class="pff-right-empty-txt">
              Click on the eye icon to view <br />
              Job Details
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getVendorJd, getSingleForm } from "../../utils/apiFunctions";
import { filteredFields } from "../../controllers/commonHelpers";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import {
  checkFieldKeys,
  isHtmlContent,
  checkValuesOfKey,
} from "../../utils/customFields";

export default {
  name: "VendorJobs",
  data() {
    return {
      showAdvanced: false,
      jobpreview: false,
      showLoader: false,
      sortColumn: "updatedAt",
      sortOrder: "-1",
      page: 0,
      total: 0,
      type: 1,
      count: 20,
      pageEnd: null,
      customerSort: null,
      selectedSort: false,
      vendorDetails: [],
      normalFields: [],
      advancedFields: [],
      showFilterCard: false,
      LoaderStatus: false,
      sortCard: false,
      typeCard: false,
      selectedJD: [],
      customerType: null,
      sort_options: [
        { text: "Name(Asce)", value: "1" },
        { text: "Name(Desc)", value: "2" },
        { text: "Recent", value: "6" },
      ],
    };
  },
  computed: {
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    ...mapGetters("userVUEX", {
      vendorData: "getVendorData",
    }),
    selectedJDProcess() {
      const invalidRounds = [0, "F", "H", "R", "NI"];
      return this.selectedJD.interviewProcess.process.filter(
        (process) =>
          !invalidRounds.includes(process.id) && process.id <= this.vendorRounds
      );
    },
    selectedJDPanelist() {
      let panelists = "";

      this.selectedJD.assignedPanelist.forEach(
        (panelist) => (panelists += panelist.username + ", ")
      );
      return panelists.substring(0, panelists.length - 2);
    },
    selectedJDVendors() {
      let vendors = "";
      this.selectedJD.vendor.forEach(
        (vendor) => (vendors += vendor.name + ", ")
      );
      return vendors.substring(0, vendors.length - 2);
    },
    selectedJDRecruiters() {
      let recruiters = "";
      this.selectedJD.assignedTo.forEach(
        (recruiter) => (recruiters += recruiter.username + ", ")
      );
      return recruiters.substring(0, recruiters.length - 2);
    },
    sortName() {
      if (this.customerSort == "1") {
        return "Name(Asce)";
      } else if (this.customerSort == "2") {
        return "Name(Desc)";
      }
      return "Recent";
    },
    vendorRounds() {
      let current = this.selectedJD.vendor.find(
        (obj) => obj.vendorID == this.$route.params.vendorID
      );
      return current.noOfRoundsToTake;
    },
  },
  components: {
    Spinner,
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          this.resetPagination();
        }
      }
    },
  },
  methods: {
    filteredFields() {
      return filteredFields(
        this.normalFields,
        this.advancedFields,
        this.selectedJD
      );
    },
    gotoClient() {
      this.$router.push({
        name: "clientdashboard",
      });
    },
    showPreview(job) {
      if (!this.jobpreview) {
        this.selectedJD = job;
        this.jobpreview = true;
      } else {
        if (job.jobID != this.selectedJD.jobID) {
          this.selectedJD = job;
        } else {
          this.selectedJD = {};
          this.jobpreview = false;
        }
      }
    },
    formattedDate(inputDate, format) {
      const date = new Date(inputDate);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      format = format.replace("MM", month.toString().padStart(2, "0"));
      if (format.indexOf("yyyy") > -1) {
        format = format.replace("yyyy", year.toString());
      } else if (format.indexOf("yy") > -1) {
        format = format.replace("yy", year.toString().substr(2, 2));
      }
      format = format.replace("dd", day.toString().padStart(2, "0"));
      return format;
    },
    checkFieldKeys(field) {
      return checkFieldKeys(field, this.selectedJD);
    },
    isHtmlContent(field) {
      return isHtmlContent(field, this.selectedJD);
    },
    checkValuesOfKey(field) {
      return checkValuesOfKey(field, this.selectedJD);
    },
    async getCustomFields(data) {
      try {
        let payload = {
          parentID: data,
        };
        const res = await getSingleForm(payload);
        if (res.status == 200) {
          const customFields = res.data.data.fields;
          for (const field of customFields) {
            if (field.category === 1 && field.key !== "openingsCount") {
              this.normalFields.push(field);
            } else {
              this.advancedFields.push(field);
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    hideSortDropdown() {
      this.sortCard = false;
      if (!this.selectedSort) {
        this.customerSort = null;
      }
    },
    hideFilterBox() {
      this.showFilterCard = false;
      if (!this.selectedSort) {
        this.customerSort = null;
      }
    },
    resetSort() {
      (this.customerSort = null), (this.sortColumn = "updatedAt");
      this.sortOrder = "-1";
      this.selectedSort = false;
      this.cancelFilter();
      this.resetPagination();
    },
    applyFilter() {
      this.selectedSort = true;
      this.cancelFilter();
      if (this.customerSort == "1") {
        this.sortColumn = "title";
        this.sortOrder = "1";
      } else if (this.customerSort == "2") {
        this.sortColumn = "title";
        this.sortOrder = "-1";
      } else {
        this.sortColumn = "updatedAt";
        this.sortOrder = "-1";
      }
      this.resetPagination();
    },
    cancelFilter() {
      this.sortCard = false;
      this.showFilterCard = false;
    },
    onScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        // Check if there is more data to load.
        if (this.checkbetween(this.pageEnd, 0, this.total)) {
          this.page++;

          this.getData();
        }
      }
    },
    checkbetween(x, min, max) {
      // Return `true` if `x` is between `min` and `max`, otherwise `false`.
      return x > min && x < max;
    },
    resetPagination() {
      this.page = 0;
      this.vendorDetails = [];
      this.LoaderStatus = true;
      this.showLoader = false;
      this.getData();
    },
    goToKanban(job) {
      this.$router.push({
        name: "VendorKanban",
        params: {
          client: this.$route.params.client,
          vendorID: this.$route.params.vendorID,
        },
        query: {
          jobID: job.jobID,
          clientName: this.$route.query.clientName,
          jobTitle: job.title,
          vendorID: this.$route.params.vendorID,
        },
      });
    },
    async getData() {
      try {
        let payload = {
          searchQuery: this.searchQuery,
          sortBy: this.sortColumn,
          order: this.sortOrder,
          page: this.page,
          count: this.count,
          vendorID: this.$route.params.vendorID,
        };
        const response = await getVendorJd(payload);
        if (response.status == 200) {
          if (this.page == 0) {
            this.vendorDetails = response.data.data.data;
          } else {
            this.vendorDetails = [
              ...this.vendorDetails,
              ...response.data.data.data,
            ];
          }

          this.total = response.data.data.total;
          this.pageEnd = response.data.data.pageEnd;
          this.vendorDetails.map((obj) => {
            if (obj.vendor) {
              let currentvendor = obj.vendor.find((obj) => {
                return obj.vendorID == this.$route.params.vendorID;
              });
              if (currentvendor.noOfCandidatesToPush) {
                return (obj.positions = currentvendor.noOfCandidatesToPush);
              } else {
                return (obj.positions = obj.details.positions);
              }
            }
          });
          this.showLoader = false;
          this.LoaderStatus = false;
          if (response.data.data.total == response.data.data.pageEnd) {
            this.showLoader = false;
          } else {
            this.showLoader = true;
          }
        }
      } catch (error) {
        this.LoaderStatus = false;

        return error;
      }
    },
  },
  created() {
    this.LoaderStatus = true;
    this.$store.commit("searchVUEX/saveSearchQuery", "");
    this.getCustomFields("1");
    this.getData();
  },
};
</script>

<style>
.selected-job-card {
  border: 2px solid #20639b !important;
}
.wb-subheading {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
}
.new-cardv-main {
  width: 290px;
  height: 150px;
  padding: 10px;
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
  margin-right: 20px;
  margin-top: 15px;
  border: 2px solid #ffffff;
}

.tp-cardv-main-1 {
  width: 290px;
  height: 162px;
  padding: 10px;
  background: #ebf5fe;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.3);
  border-radius: 8px;
  margin-right: 20px;
  margin-top: 20px;
  border: 2px solid #84bae7;
}
.wb-custcards-heading {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  color: #000000;
}
.wb-new-greenfont {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #038e00;
}
.wb-new-bluefont {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #5782ff;
}
.wb-new-yellowfont {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #ffc145;
}
.wb-new-greyfont {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #7a7a7a;
}
.new-wb-subcards {
  height: 73px;
  border-radius: 10px;
  background: rgba(32, 99, 155, 0.1);
  position: absolute;
  width: 93%;
  bottom: 10px;
}
</style>
